<template>
  <div id="person">
    <div id="content">
      <Header
        :page="type"
        :title_one="title_two"
        :person_id="this.$route.params.person_id"
        :action_one="event.main_actions ? 'edit' : ''"
      ></Header>

      <div class="left">
        <div class="title">{{ $t("titles.form_person_info") }}</div>
        <!-- <div class="title">{{person.name +" "+ person.surname}} ({{$t('titles.' + type)}})</div> -->
        <div class="row">
          <div class="item">
            <div class="label">{{ $t("params.name") }}</div>
            <div class="value">{{ person.name }}</div>
          </div>
          <div class="item">
            <div class="label">{{ $t("params.surname") }}</div>
            <div class="value">{{ person.surname }}</div>
          </div>
          <div class="item">
            <div class="label">
              {{ $t("params." + person.document_type_text) }}
            </div>
            <div class="value">{{ person.dni }}</div>
          </div>
          <div class="item" v-if="typeof person.birthday !== 'undefined'">
            <div class="label">{{ $t("params.birthday") }}</div>
            <div class="value">{{ person.birthday }}</div>
          </div>
          <div class="item" v-if="typeof person.nacionality !== 'undefined'">
            <div class="label">{{ $t("params.nacionality") }}</div>
            <div
              class="value"
              v-if="
                typeof countries !== 'undefined' &&
                  typeof countries[person.nacionality] !== 'undefined'
              "
            >
              {{ countries[person.nacionality].name }}
            </div>
          </div>
          <div class="item" v-if="typeof person.gender !== 'undefined'">
            <div class="label">{{ $t("params.gender") }}</div>
            <div class="value">
              {{
                person.gender != "0"
                  ? person.gender == "1"
                    ? $t("gender.male")
                    : $t("gender.female")
                  : "-"
              }}
            </div>
          </div>
          <!--
                <div class="item mid" v-if="typeof person.altura !== 'undefined'">
                    <div class="label">{{$t('params.altura')}}</div>
                    <div class="value">{{person.altura != 0 ? person.altura : '-'}}</div>
                </div>
                -->
          <!--
                <div class="item" v-if="typeof person.swim !== 'undefined'">
                    <div class="label">{{$t('swim')}}</div>
                    <div class="value">{{person.swim ? $t('si') : $t('no')}}</div>
                </div>
                -->
        </div>

        <div class="title">{{ $t("titles.form_person_medical") }}</div>
        <div class="row">
          <div class="item" v-if="typeof person.alergy !== 'undefined'">
            <div class="label">{{ $t("params.alergy") }}</div>

            <div
              class="value"
              v-if="typeof person.alergy != 'undefined' && person.alergy != ''"
            >
              <span
                class="alergy"
                v-for="alergy in person.alergy"
                v-bind:key="alergy.id"
              >
                <template v-if="alergies[alergy]">
                  {{ $t("alergy." + alergies[alergy].name) }}
                </template>
              </span>
            </div>
            <div class="value" v-else>{{ $t("no") }}</div>
          </div>

          <div class="item">
            <div class="label">{{ $t("params.other_allergies") }}</div>
            <div class="value">
              {{ person.other_allergies ? person.other_allergies : "-" }}
            </div>
          </div>

          <div class="item">
            <div class="label">{{ $t("params.diet") }}</div>
            <div class="value">
              {{
                person.diet && diets[person.diet]
                  ? $t(diets[person.diet].name)
                  : "-"
              }}
            </div>
          </div>

          <!--
                <div class="item" v-if="typeof person.b_medicamento !== 'undefined'">
                    <div class="label">{{$t('params.medicamento')}}</div>
                    <div class="value">{{person.b_medicamento ? person.medicamento : $t('no')}}</div>
                </div>
                -->
        </div>

        <div class="title" v-if="type == 'player'">
          {{ $t("titles.responsables") }}
        </div>

        <!-- <div class="title sub" v-if="type == 'player' && Object.keys(person.responsable1).length">{{ person.responsable1.name+" "+person.responsable1.surname }}</div> -->
        <div
          v-if="type == 'player' && Object.keys(person.responsable1).length"
          class="row"
        >
          <div class="item">
            <div class="label">{{ $t("params.name") }}</div>
            <div class="value">{{ person.responsable1.name }}</div>
          </div>
          <div class="item">
            <div class="label">{{ $t("params.surname") }}</div>
            <div class="value">{{ person.responsable1.surname }}</div>
          </div>
          <div class="item">
            <div class="label">
              {{ $t("params." + person.responsable1.document_type_text) }}
            </div>
            <div class="value">{{ person.responsable1.dni }}</div>
          </div>
          <div class="item">
            <div class="label">{{ $t("params.phone") }}</div>
            <div class="value">{{ person.responsable1.phone }}</div>
          </div>
          <!--
                <div class="item">
                    <div class="label">{{$t('params.phone2')}}</div>
                    <div class="value">{{person.responsable1.phone2}}</div>
                </div>
                -->
          <div class="item">
            <div class="label">{{ $t("params.email") }}</div>
            <div class="value">{{ person.responsable1.email }}</div>
          </div>
          <!--
                <div class="item">
                    <div class="label">{{$t('params.email2')}}</div>
                    <div class="value">{{person.responsable1.email2}}</div>
                </div>
                -->
        </div>

        <!-- <div class="title sub" v-if="type == 'player' && Object.keys(person.responsable2).length">{{ person.responsable2.name+" "+person.responsable2.surname }}</div> -->
        <div
          v-if="type == 'player' && Object.keys(person.responsable2).length"
          class="row"
        >
          <div class="item">
            <div class="label">{{ $t("params.name") }}</div>
            <div class="value">{{ person.responsable2.name }}</div>
          </div>
          <div class="item">
            <div class="label">{{ $t("params.surname") }}</div>
            <div class="value">{{ person.responsable2.surname }}</div>
          </div>
          <div class="item">
            <div class="label">
              {{ $t("params." + person.responsable2.document_type_text) }}
            </div>
            <div class="value">{{ person.responsable2.dni }}</div>
          </div>
          <div class="item">
            <div class="label">{{ $t("params.phone") }}</div>
            <div class="value">{{ person.responsable2.phone }}</div>
          </div>
          <!--
                <div class="item">
                    <div class="label">{{$t('params.phone2')}}</div>
                    <div class="value">{{person.responsable2.phone2}}</div>
                </div>
                -->
          <div class="item">
            <div class="label">{{ $t("params.email") }}</div>
            <div class="value">{{ person.responsable2.email }}</div>
          </div>
          <!--
                <div class="item">
                    <div class="label">{{$t('params.email2')}}</div>
                    <div class="value">{{person.responsable2.email2}}</div>
                </div>
                -->
        </div>

        <div
          v-if="
            type == 'player' &&
              (!Object.keys(person.responsable1).length ||
                !Object.keys(person.responsable2).length)
          "
          class="row empty"
        >
          {{ $t("params.no_responsable") }}
        </div>
      </div>

      <div class="right">
        <div class="title" v-if="type != 'acompanyant'">
          {{ $t("titles.form_person_team") }}
        </div>
        <div class="row" v-if="type != 'acompanyant'">
          <!-- {{person}} -->
          <!-- <Equipment class="equip" v-if="team.local_uniform" :equipment="team.local_uniform" :is_preview="true" :class="{'empty': team.local_uniform.socks_color == null }"></Equipment> -->

          <div class="item mid" v-if="typeof person.number !== 'undefined'">
            <div class="label">{{ $t("params.number") }}</div>
            <div class="value">{{ person.number }}</div>
          </div>
          <div class="item mid" v-if="typeof person.position !== 'undefined'">
            <div class="label">{{ $t("params.position") }}</div>
            <div
              class="value"
              v-if="
                typeof positions !== 'undefined' &&
                  typeof positions[person.position] !== 'undefined'
              "
            >
              {{ $t(positions[person.position].name) }}
            </div>
          </div>
          <div class="item" v-if="typeof person.nivel !== 'undefined'">
            <div class="label">{{ $t("params.staff_level") }}</div>
            <div class="value" v-if="staff_level && staff_level[person.nivel]">
              {{ $t("staff_level." + staff_level[person.nivel].name) }}
            </div>
          </div>
          <div class="item" v-if="person.contact_type !== 'undefined'">
            <div class="label">{{ $t("params.contact_type") }}</div>
            <div class="value">
              {{
                person.contact_type != "" && contact_type[person.contact_type]
                  ? $t(contact_type[person.contact_type].name)
                  : "-"
              }}
            </div>
          </div>
        </div>

        <div class="title">{{ $t("titles.form_person_contact") }}</div>
        <div class="row">
          <div class="item mid">
            <div class="label">{{ $t("params.phone") }}</div>
            <div class="value">
              {{ person.phone != "" ? person.phone : "-" }}
            </div>
          </div>
          <!--
                <div class="item mid">
                    <div class="label">{{$t('params.phone2')}}</div>
                    <div class="value">{{person.phone2 != '' ? person.phone2 : '-'}}</div>
                </div>
                -->
          <div class="item mid">
            <div class="label">{{ $t("params.email") }}</div>
            <div class="value">
              {{ person.email != "" ? person.email : "-" }}
            </div>
          </div>
          <!--
                <div class="item mid">
                    <div class="label">{{$t('params.email2')}}</div>
                    <div class="value">{{person.email2 != '' ? person.email2 : '-'}}</div>
                </div>
                -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* global isEmpty moment */
import Header from '@/components/layout/Header'

export default {
  name: 'Person',
  components: {
    Header
  },
  data () {
    return {
      type: '',
      title_two: '',
      user: {},
      countries: {},
      positions: {},
      alergies: {},
      staff_level: {},
      diets: {},
      contact_type: {},
      person: {
        name: '',
        surname: '',
        phone: '',
        // phone2: '',
        email: '',
        // email2: '',
        dni: '',
        responsable1: {},
        responsable2: {},
        alergy: '',
        other_allergies: ''
      },
      error: {
        responsable: false
      }
    }
  },
  created () {
    // scroll to top
    window.scroll(0, 0)
    // get user
    this.user = this.$store.getters['user/getUser']
    // save type:
    this.type = this.$route.name
    var self = this
    // check if type is player
    if (this.type === 'player') {
      this.$store
        .dispatch('person/loadPlayer', {
          person_id: this.$route.params.person_id
        })
        .then(function () {
          let data = self.$store.getters['person/getPerson']
          // load team for left and header
          self.$store
            .dispatch('team/loadTeam', { team_id: data.team })
            .then(function () {
              self.countries = self.$store.getters['getCountries']
              self.positions = self.$store.getters['getPlayerPositions']
              self.alergies = self.$store.getters['getAlergy']
              self.diets = self.$store.getters['getDiets']
              // Object.keys(data.responsables).length > 0 ? self.responsables = data.responsables : self.responsables = {};
            })
          self.person.name = data.name
          self.person.surname = data.surname
          self.person.phone = data.phone
          // self.person.phone2           =      data.phone2;
          self.person.email = data.email
          // self.person.email2           =      data.email2;
          self.person.document_type = data.document_type
          self.person.dni = data.dni
          self.person.b_alergy = data.b_alergy
          self.person.alergy = data.alergy
          self.person.other_allergies = data.other_allergies
          self.person.diet = data.diet
          self.person.birthday = !isEmpty(data.birthday)
            ? moment(data.birthday).format('DD/MM/YYYY')
            : null
          self.person.gender = data.gender ? data.gender : ''
          self.person.country = data.country
          self.person.nacionality = data.nacionality
          self.person.address = data.address
          self.person.cp = data.cp
          self.person.city = data.city
          self.person.state = data.state
          self.person.number = data.number
          self.person.position = data.position
          // self.person.b_medicamento    =      data.b_medicamento;
          // self.person.medicamento      =      data.medicamento;
          // self.person.swim             =      data.swim;
          // self.person.altura           =      data.altura;

          // document type
          switch (self.person.document_type) {
            case '1':
              self.person.document_type_text = 'dni'
              break
            case '2':
              self.person.document_type_text = 'nie'
              break
            case '3':
              self.person.document_type_text = 'passport'
              break
          }

          if (data.responsable1 != null) {
            self.person.responsable1.name = data.responsable1.name
            self.person.responsable1.surname = data.responsable1.surname
            self.person.responsable1.document_type =
              data.responsable1.document_type
            self.person.responsable1.dni = data.responsable1.dni
            self.person.responsable1.phone = data.responsable1.phone
            self.person.responsable1.email = data.responsable1.email
            // self.person.responsable1.phone2     =       data.responsable1.phone2;
            // self.person.responsable1.email2     =       data.responsable1.email2;

            switch (self.person.responsable1.document_type) {
              case '1':
                self.person.responsable1.document_type_text = 'dni'
                break
              case '2':
                self.person.responsable1.document_type_text = 'nie'
                break
              case '3':
                self.person.responsable1.document_type_text = 'passport'
                break
            }
          }

          if (data.responsable2 != null) {
            self.person.responsable2.name = data.responsable2.name
            self.person.responsable2.surname = data.responsable2.surname
            self.person.responsable2.document_type =
              data.responsable2.document_type
            self.person.responsable2.dni = data.responsable2.dni
            self.person.responsable2.phone = data.responsable2.phone
            self.person.responsable2.email = data.responsable2.email
            // self.person.responsable2.phone2     =       data.responsable2.phone2;
            // self.person.responsable2.email2     =       data.responsable2.email2;

            switch (self.person.responsable2.document_type) {
              case '1':
                self.person.responsable2.document_type_text = 'dni'
                break
              case '2':
                self.person.responsable2.document_type_text = 'nie'
                break
              case '3':
                self.person.responsable2.document_type_text = 'passport'
                break
            }
          }
        })
      // regular person
    } else {
      this.$store
        .dispatch('person/loadPerson', {
          person_id: this.$route.params.person_id
        })
        .then(function () {
          var data = self.$store.getters['person/getPerson']
          // load team for left and header
          self.$store
            .dispatch('team/loadTeam', { team_id: data.team })
            .then(function () {
              self.alergies = self.$store.getters['getAlergy']
              self.staff_level = self.$store.getters['getStaffLevel']
              self.diets = self.$store.getters['getDiets']
              self.contact_type = self.$store.getters['getContactType']
            })
          self.person.name = data.name
          self.person.surname = data.surname
          self.person.phone = data.phone
          // self.person.phone2           =      data.phone2;
          self.person.email = data.email
          // self.person.email2           =      data.email2;
          self.person.dni = data.dni
          self.person.b_alergy = data.b_alergy
          self.person.alergy = data.alergy
          self.person.other_allergies = data.other_allergies
          self.person.diet = data.diet
          self.person.nivel = data.nivel
          self.person.gender = data.gender ? data.gender : ''
          self.person.contact_type = data.contact_type_id
            ? data.contact_type_id
            : ''

          // document type
          switch (self.person.document_type) {
            case '1':
              self.person.document_type_text = 'dni'
              break
            case '2':
              self.person.document_type_text = 'nie'
              break
            case '3':
              self.person.document_type_text = 'passport'
              break
          }
        })
    }

    if (
      this.user.admin &&
      Object.keys(this.$store.getters['club/getClub']).length < 1
    ) {
      this.$store
        .dispatch('club/loadClubEvent', {
          club_id: this.user.club_id,
          event_id: this.user.event_id
        })
        .then(function () {})
    }
    switch (this.type) {
      case 'player':
        this.title_two = 'player'
        break
      case 'staff':
      case 'coach':
        this.title_two = 'staff'
        break
      case 'acompanyant':
        this.title_two = 'acompanyant'
        break
    }
  },
  methods: {
    redirect () {
      var id = this.$route.params.person_id
      switch (this.type) {
        case 'player':
          this.$router
            .push({ name: 'player_edit', params: { person_id: id } })
            .catch()
          break
        case 'coach':
          this.$router
            .push({ name: 'staff_edit', params: { person_id: id } })
            .catch()
          break
        case 'acompanyant':
          this.$router
            .push({ name: 'acompanyant_edit', params: { person_id: id } })
            .catch()
          break
      }
    }
  },
  computed: {
    event () {
      return this.$store.getters['getCurrentEvent']()
    }
  }
}
</script>
<style lang="scss" scoped>
.mobile {
  display: none;
}

#content {
  padding: 0 12px !important;

  .row {
    background-color: #f5f5f5;
    border-radius: 3px;
    text-align: center;
    overflow: hidden;
    margin-bottom: 24px;
    padding: 6px 12px;
    height: auto;
    // min-height: 100px;

    .item {
      display: inline-block;
      margin-bottom: 6px;
      width: 100%;

      &.mid {
        width: 50%;
      }

      .alergy {
        color: inherit;
        font-size: inherit;
        font-weight: inherit;

        &:after {
          content: ", ";
        }
        &:last-of-type:after {
          content: "";
        }
      }
    }

    .label,
    .value {
      display: inline-block;
      font-size: 15px;
    }
    .label {
      width: 100px;
      text-align: right;
      margin-right: 12px;
      text-transform: uppercase;
      font-size: 12px;

      &:after {
        content: ":";
      }
    }
    .value {
      font-weight: bold;
    }
  }

  .title {
    font-size: 16px !important;
    font-weight: bold;
    color: $main-color-t30;
    display: block;
    width: 100%;
    margin: 6px;

    &.sub {
      margin-left: 12px;
    }
  }

  .person {
    background: none;
    width: 100%;
    overflow: hidden;
    text-align: left;

    .person-role,
    .person-name {
      @include text-ellipsis();
      display: block;
      font-size: 24px;
      color: $main-color;
      width: 100%;
      padding: 2px;
    }

    .person-role {
      margin-right: 6px;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 16px;
      line-height: 16px;
    }
  }

  .left,
  .right {
    width: 50%;
    display: inline-block;
    padding: 12px;
  }
}

@include media("<=desktop") {
  #content {
    padding: 12px !important;

    .left,
    .right {
      width: 100%;
      display: block;
      padding: 0;
    }
  }
}

@include media(">phone", "<tablet") {
  #content {
    .row {
      .item {
        &.mid {
          width: 100%;
        }
      }
    }
  }
}
</style>
